import React from 'react';
import '../less/index.less';
import hero_img from '../img/hero_img.png';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import QuestionsAdminNew from '../../../../../auxiliary-components/shared/QuestionsAdminNew';
import FilesForDownloadNew from "../../../../../auxiliary-components/shared/FilesForDownloadNew";
import TextAboveFooterNew from "../../../../../auxiliary-components/shared/TextAboveFooterNew";
import FAQStorybook from '@abank/abank-faq';
import how_to_block_img_1 from '../img/how_to_block_img_1.png';
import how_to_block_img_2 from '../img/how_to_block_img_2.png';
import how_to_block_img_3 from '../img/how_to_block_img_3.png';
import HowToBlockNew from '../../../../../auxiliary-components/shared/HowToBlockNew';
import { instantCashTerms, instantCashLink } from '../../../../../services/urls/urls';
import Tariffs from '../../../../../auxiliary-components/shared/TariffsBlock';
import tariffsData from '../../../enums/instant_cash/tariffs_data.json';
import { filterByEnvironment } from '../../../../../helpers/utils/environmentFilter';

export default function template() {
    const hero_data = {
      title: 'INSTANT_CASH_HERO_TITLE',
      text: 'INSTANT_CASH_HERO_TEXT',
      link: {
        text: "INSTANT_CASH_HERO_BTN",
        onClick: () => window.open(instantCashLink, '_self'),
      },
    }

    const howToBlockItems = [
      {
        img: how_to_block_img_1,
        title: 'INSTANT_CASH_HOW_TO_TITLE_01',
        text: 'INSTANT_CASH_HOW_TO_TEXT_01',
      },
      {
        img: how_to_block_img_2,
        title: 'INSTANT_CASH_HOW_TO_TITLE_02',
        text: 'INSTANT_CASH_HOW_TO_TEXT_02',
      },
      {
        img: how_to_block_img_3,
        title: 'INSTANT_CASH_HOW_TO_TITLE_03',
        text: 'INSTANT_CASH_HOW_TO_TEXT_03',
      }
    ];

    const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

    return (
      <div className="instant-cash">
        <Hero
          data={hero_data}
          img={hero_img}
        />
        <div className={`content${this.state.faqTab ? ' hidden' : ''}`}>
          <Tariffs
            items={tariffsData}
            title={'INSTANT_CASH_TARIFFS_TITLE'}
            btnLink={instantCashTerms}
            btnText={'INSTANT_CASH_TARIFFS_BTN'}
          />
          <HowToBlockNew
            title={'INSTANT_CASH_HOW_TO_TITLE'}
            items={howToBlockItems}
          />
          <QuestionsAdminNew
            widget={questionsWidget}
            toggleFaqTab={this.toggleFaqTab}
            title={'INSTANT_CASH_QUESTIONS_TITLE'}
          />
          <FilesForDownloadNew
            lang={this.props.lang}
            widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
          />
          <TextAboveFooterNew
            widget={this.widgetsHelper.getWidget.call(this, 'text_above_footer')}
          />
        </div>
        <div className={`content${!this.state.faqTab ? ' hidden' : ''}`}>
          <FAQStorybook
            widget={questionsWidget}
            title={this.l10n('INSTANT_CASH_FAQ_STORYBOOK_TITLE')}
            btnText={this.l10n('INSTANT_CASH_FAQ_STORYBOOK_BTN_TEXT')}
            onBtnClick={this.toggleFaqTab}
            filterByEnvironment={filterByEnvironment}
          />
        </div>
      </div>
    );
}
